import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';

function ScrollToTop({ history, children }) {
  useEffect(() => {
    const windowListen = history.listen(() => {
      window.scrollTo(0, 0);
    });
    return () => {
      windowListen();
    };
  }, [history]);

  return <>{children}</>;
}

export default withRouter(ScrollToTop);
